import React from 'react';
// import { colors } from "../../styles/theme"

export function CapacityIcon(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="far"
      data-icon="capacity"
      viewBox="0 0 130 130"
      {...props}
    >
      <g>
        <g>
          <g>
            <path d="M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z"></path>
            <path d="M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z"></path>
            <path d="M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z"></path>
            <path d="M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z"></path>
          </g>
          <g>
            <path d="M20.8,24.8l13,13l4-4l-13-13h6.3v-5.6H18c-1.6,0-2.8,1.3-2.8,2.8v13.1h5.6V24.8z"></path>
            <path d="M18,84.8h13.1v-5.6h-6.3l13-13l-4-4l-13,13v-6.3h-5.6V82C15.2,83.6,16.4,84.8,18,84.8z"></path>
            <path d="M68.9,79.2v5.6H82c1.6,0,2.8-1.3,2.8-2.8V68.9h-5.6v6.3l-13-13l-4,4l13,13H68.9z"></path>
            <path d="M66.2,37.8l13-13v6.3h5.6V18c0-1.6-1.3-2.8-2.8-2.8H68.9v5.6h6.3l-13,13L66.2,37.8z"></path>
            <path d="M94.7,2.5H5.3c-1.6,0-2.8,1.3-2.8,2.8v89.4c0,1.6,1.3,2.8,2.8,2.8h89.4c1.6,0,2.8-1.3,2.8-2.8V5.3     C97.5,3.8,96.2,2.5,94.7,2.5z M91.9,91.9H8.1V8.1h83.7V91.9z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function DamIcon(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="far"
      data-icon="dam"
      viewBox="0 0 100 100"
      {...props}
    >
      <path d="M90.5 82h-45c-1.104 0-2-0.9-2-2v-64c0-1.104 0.896-2 2-2h20c1.1 0 2 0.896 2 2v38c0 13.456 10.1 24 23 24 1.1 0 2 0.9 2 2s-0.9 2-2 2zM47.5 78h28.9c-7.788-4.86-12.9-13.696-12.9-24v-36h-16v60z"></path>
      <path d="M37.5 26c-3.268 0-6.172-1.576-8-4.004-1.828 2.428-4.732 4.004-8 4.004s-6.172-1.576-8-4.004c-1.828 2.428-4.732 4.004-8 4.004-1.104 0-2-0.896-2-2s0.896-2 2-2c3.308 0 6-2.692 6-6 0-1.104 0.896-2 2-2s2 0.896 2 2c0 3.308 2.692 6 6 6s6-2.692 6-6c0-1.104 0.896-2 2-2s2 0.896 2 2c0 3.308 2.692 6 6 6s6-2.692 6-6c0-1.104 0.896-2 2-2s2 0.896 2 2c0 5.512-4.488 10-10 10z"></path>
      <path d="M37.5 42c-3.268 0-6.172-1.576-8-4.004-1.828 2.428-4.732 4.004-8 4.004s-6.172-1.576-8-4.004c-1.828 2.428-4.732 4.004-8 4.004-1.104 0-2-0.896-2-2s0.896-2 2-2c3.308 0 6-2.692 6-6 0-1.104 0.896-2 2-2s2 0.896 2 2c0 3.308 2.692 6 6 6s6-2.692 6-6c0-1.104 0.896-2 2-2s2 0.896 2 2c0 3.308 2.692 6 6 6s6-2.692 6-6c0-1.104 0.896-2 2-2s2 0.896 2 2c0 5.512-4.488 10-10 10z"></path>
      <path d="M37.5 58c-3.268 0-6.172-1.58-8-4.004-1.828 2.424-4.732 4.004-8 4.004s-6.172-1.58-8-4.004c-1.828 2.424-4.732 4.004-8 4.004-1.104 0-2-0.9-2-2s0.896-2 2-2c3.308 0 6-2.692 6-6 0-1.104 0.896-2 2-2s2 0.896 2 2c0 3.308 2.692 6 6 6s6-2.692 6-6c0-1.104 0.896-2 2-2s2 0.896 2 2c0 3.308 2.692 6 6 6s6-2.692 6-6c0-1.104 0.896-2 2-2s2 0.896 2 2c0 5.512-4.488 10-10 10z"></path>
      <path d="M43.5 66h-36c-1.104 0-2-0.9-2-2s0.896-2 2-2h36c1.104 0 2 0.9 2 2s-0.896 2-2 2z"></path>
      <path d="M51.5 82h-44c-1.104 0-2-0.9-2-2s0.896-2 2-2h44c1.1 0 2 0.9 2 2s-0.9 2-2 2z"></path>
    </svg>
  );
}

export function StorageLevelIcon(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="far"
      data-icon="dam"
      viewBox="15 15 70 70"
      {...props}
    >
      <g>
        <polygon points="56.81 57.211 48.727 52.747 40.643 57.211 32.56 52.747 24.476 57.211 16.876 53.014 15.91 54.764 16.395 55.033 16.393 55.032 24.476 59.496 24.476 59.496 24.477 59.496 32.56 55.032 40.643 59.496 48.727 55.032 56.81 59.496 56.81 59.496 56.81 59.496 64.893 55.032 64.891 55.033 65.376 54.764 64.41 53.014 56.81 57.211"></polygon>
        <polygon points="64.41 65.014 56.81 69.211 48.727 64.747 40.643 69.211 32.56 64.747 24.476 69.211 16.876 65.014 15.91 66.764 16.395 67.033 16.393 67.032 24.476 71.496 24.476 71.496 24.477 71.496 32.56 67.032 40.643 71.496 48.727 67.032 56.81 71.496 56.81 71.496 56.81 71.496 64.893 67.032 64.891 67.033 65.376 66.764 64.41 65.014"></polygon>
        <polygon points="56.81 45.211 48.727 40.747 40.643 45.211 32.56 40.747 24.476 45.211 16.876 41.014 15.91 42.765 20.609 45.359 24.476 47.495 24.476 47.495 24.477 47.495 32.56 43.031 40.643 47.495 48.727 43.031 56.81 47.495 56.81 47.495 56.81 47.495 60.677 45.359 65.376 42.765 64.41 41.014 56.81 45.211"></polygon>
        <polygon points="56.81 33.211 48.727 28.747 40.643 33.211 32.56 28.747 24.476 33.211 16.876 29.014 15.91 30.764 16.395 31.033 16.393 31.032 24.476 35.496 24.476 35.496 24.477 35.496 32.56 31.032 40.643 35.496 48.727 31.032 56.81 35.496 56.81 35.496 56.81 35.496 64.893 31.032 64.891 31.033 65.376 30.764 64.41 29.014 56.81 33.211"></polygon>
        <polygon points="79 68.243 79 31.757 82.95 35.707 84.364 34.292 78 27.929 71.636 34.292 73.05 35.707 77 31.757 77 68.243 73.05 64.293 71.636 65.707 78 72.071 84.364 65.707 82.95 64.293 79 68.243"></polygon>
      </g>
    </svg>
  );
}

export function ServiceChargeIcon(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="far"
      data-icon="dam"
      viewBox="5 10 70 70"
      {...props}
    >
      <path d="M11.6572266,62.2271118c2.5673828,0,4.65625-2.0888672,4.65625-4.65625v-1.1699219h12.4462891v0.1953125  c0,1.4306641,1.1630859,2.59375,2.59375,2.59375h17.2314453c1.4306641,0,2.59375-1.1630859,2.59375-2.59375v-0.1953125H63.6875  v1.1699219c0,2.5673828,2.0888672,4.65625,4.65625,4.65625S73,60.1382446,73,57.5708618V38.3892212  c0-2.5673828-2.0888672-4.65625-4.65625-4.65625s-4.65625,2.0888672-4.65625,4.65625v1.1708984H51.1787109v-0.1953125  c0-1.4306641-1.1630859-2.59375-2.59375-2.59375h-0.4277344v-3.1308594c0-0.7626953-0.6201172-1.3828125-1.3818359-1.3828125  h-2.5361328v-6.3257446l7.0576172,0.6587524c0.1357422,0.0126953,0.2714844,0.0185547,0.4072266,0.0185547  c1.0957031,0,2.1640625-0.4091797,2.9794922-1.1533203c0.9169922-0.8349609,1.4423828-2.0253906,1.4423828-3.2646484  c0-1.2402344-0.5253906-2.4296875-1.4423828-3.2646484c-0.9160156-0.8359375-2.1523438-1.2490234-3.3867188-1.1347656  l-8.0576172,0.7558594l-6.3857422,0.0039063l-8.1503906-0.7597656c-1.2294922-0.1132813-2.46875,0.2988281-3.3857422,1.1337891  S23.875,20.9507446,23.875,22.190979s0.5253906,2.4296875,1.4423828,3.265625  c0.9179688,0.8349609,2.1552734,1.2490234,3.3857422,1.1337891l7.0576172-0.6590576v6.3260498h-2.5351563  c-0.7617188,0-1.3818359,0.6201172-1.3818359,1.3828125v3.1308594h-0.4902344c-1.4306641,0-2.59375,1.1630859-2.59375,2.59375  v0.1953125H16.3134766v-1.1708984c0-2.5673828-2.0888672-4.65625-4.65625-4.65625C9.0888672,33.7329712,7,35.8218384,7,38.3892212  v19.1816406C7,60.1382446,9.0888672,62.2271118,11.6572266,62.2271118z M65.6875,38.3892212  c0-1.4648438,1.1914063-2.65625,2.65625-2.65625S71,36.9243774,71,38.3892212v19.1816406  c0,1.4648438-1.1914063,2.65625-2.65625,2.65625s-2.65625-1.1914063-2.65625-2.65625v-2.1699219V40.5601196V38.3892212z   M63.6875,41.5601196v12.8408203H51.1787109V41.5601196H63.6875z M28.5175781,24.5982056  c-0.6845703,0.0683594-1.34375-0.15625-1.8535156-0.6201172C26.1552734,23.5142212,25.875,22.8794556,25.875,22.190979  s0.2802734-1.3232422,0.7890625-1.7871094c0.5097656-0.4628906,1.1611328-0.6884766,1.8535156-0.6201172l8.2431641,0.7636719  l6.5712891-0.0039063l8.1503906-0.7597656c0.6992188-0.0683594,1.3447266,0.1572266,1.8544922,0.6201172  c0.5087891,0.4638672,0.7890625,1.0986328,0.7890625,1.7871094s-0.2802734,1.3232422-0.7890625,1.7871094  s-1.15625,0.6894531-1.8544922,0.6201172l-8.2431641-0.7646484h-6.4785156c-0.03125,0-0.0625,0.0009766-0.0927734,0.0039063  L28.5175781,24.5982056z M37.7607422,25.8335571h4.4785156v6.4238281h-4.4785156V25.8335571z M33.84375,34.2573853h2.9169922  h6.4785156h2.9179688v2.5136719H33.84375V34.2573853z M30.7597656,39.3648071c0-0.3271484,0.2666016-0.59375,0.59375-0.59375  H32.84375h14.3134766h1.4277344c0.3271484,0,0.59375,0.2666016,0.59375,0.59375v1.1953125v14.8408203v1.1953125  c0,0.3271484-0.2666016,0.59375-0.59375,0.59375H31.3535156c-0.3271484,0-0.59375-0.2666016-0.59375-0.59375v-1.1953125V40.5601196  V39.3648071z M28.7597656,41.5601196v12.8408203H16.3134766V41.5601196H28.7597656z M9,38.3892212  c0-1.4648438,1.1923828-2.65625,2.6572266-2.65625s2.65625,1.1914063,2.65625,2.65625v2.0256348  c-0.0075073,0.0494385-0.0292969,0.09375-0.0292969,0.1452637v14.8408203c0,0.0515137,0.0217896,0.0957642,0.0292969,0.1452026  v2.0247192c0,1.4648438-1.1914063,2.65625-2.65625,2.65625S9,59.0357056,9,57.5708618V38.3892212z"></path>
    </svg>
  );
}

export function ConsumptionChargeIcon(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="far"
      data-icon="dam"
      viewBox="0 0 70 70"
      {...props}
    >
      <g data-name="Layer 20">
        <path d="M9.376,46.7a1.039,1.039,0,0,0-1.752,0L4.557,52.275A4.565,4.565,0,0,0,4,54.5a4.5,4.5,0,1,0,8.443-2.224ZM8.5,57a2.546,2.546,0,0,1-2.191-3.761L8.5,49.257l2.191,3.983A2.564,2.564,0,0,1,11,54.5,2.5,2.5,0,0,1,8.5,57Z"></path>
        <path d="M61,58H58V24a1,1,0,0,0-1-1H54V18a9.221,9.221,0,0,0-6.4-8.8L22.429,1.059a3.386,3.386,0,0,0-2.114,6.433l18.574,6.193A4.53,4.53,0,0,1,41.876,17H41a1,1,0,0,0-1,1v5H37a1,1,0,0,0-1,1v5H10a7.008,7.008,0,0,0-7,7v6a1,1,0,0,0,1,1H14a1,1,0,0,0,1-1V37H36V58H33a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H61a1,1,0,0,0,1-1V59A1,1,0,0,0,61,58ZM39.521,11.787,20.948,5.6A1.386,1.386,0,0,1,20,4.28a1.387,1.387,0,0,1,1.813-1.319L46.984,11.1A7.227,7.227,0,0,1,51.932,17H43.924A6.537,6.537,0,0,0,39.521,11.787ZM42,19H52v4H42ZM13,41H5V37h8Zm25-4h2V35H5.1A5.008,5.008,0,0,1,10,31H42V29H38V25H56V58H38ZM60,62H34V60H60Z"></path>
        <path d="M53,27H48v2h4v3h2V28A1,1,0,0,0,53,27Z"></path>
        <rect x="52" y="34" width="2" height="22"></rect>
      </g>
    </svg>
  );
}

export function ChevronDoubleRight(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="far"
      data-icon="chevron-double-right"
      className="prefix__svg-inline--fa prefix__fa-chevron-double-right prefix__fa-w-14"
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M57.7 38.1l209.4 209.4c4.7 4.7 4.7 12.3 0 17L57.7 473.9c-4.7 4.7-12.3 4.7-17 0l-19.8-19.8c-4.7-4.7-4.7-12.3 0-17L201.6 256 20.9 74.9c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0zm143 0l-19.8 19.8c-4.7 4.7-4.7 12.3 0 17L361.6 256 180.9 437.1c-4.7 4.7-4.7 12.3 0 17l19.8 19.8c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17L217.7 38.1c-4.7-4.7-12.3-4.7-17 0z"
      />
    </svg>
  );
}

// https://fontawesome.com/icons/chalkboard-teacher?style=light
export function ArrowRight(props) {
  return (
    <svg
      aria-hidden="true"
      data-prefix="far"
      data-icon="arrow-right"
      className="prefix__svg-inline--fa prefix__fa-arrow-right prefix__fa-w-14"
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/index.js